import React, { useEffect, useState } from 'react'
import { Link, useSearchParams} from 'react-router-dom'
import Footer from '../../../Component/Footer/Footer'
import Navbar from '../Navbar/Navbar'
import { useGetClassByAgeAndGenderMutation } from '../../../Redux/Api/AuthApi'


const Details = () => {
const [resData,setResData] = useState()
const [errMsg,setErrMsg] = useState()
const [searchParams] = useSearchParams();
 // Use the .get() method to retrieve specific values
const age = searchParams.get('ages');    // Returns "2"
const gender = searchParams.get('gender'); // Returns "female"
const [getClassByAgeAndGender,{isLoading}] = useGetClassByAgeAndGenderMutation()

  useEffect(()=>{
    async function fetchClass(){
      const getClass = await getClassByAgeAndGender({age,gender})
      //console.log(getClass)
      if(getClass?.data){
        setResData(getClass?.data?.data)
        console.log(getClass?.data?.data)
      }else{
        setErrMsg(getClass?.error?.data?.message)
      }
    }
    fetchClass()
  },[age,gender,getClassByAgeAndGender])

  return (
    <div className='kiga-classes-main'>
      <Navbar/>
      {isLoading && (
       <div><p>Iz Loading.....</p></div>  
      )}
    <div className='kiga-classes-section-filter'>
     <div className='kiga-classes-section-filter-title'>
       <p>Filters </p>
     </div>
     <div className='kiga-classes-section-filter-box'>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
     </div>
    </div>
    {
      errMsg ? (
        <div><p>{errMsg}</p></div>
      ):(
    <section className='kiga-classes-section'>
      {
       resData?.selectClass?.map((item,key)=>(
     <div className='kiga-classes-section-box' key={key}>
      <Link to={`/portal/booking/classes/DetailEnroll/${item?._id}`}>
        <div className='kiga-classes-section-box-image'>
          <img src={item?.image ? item?.image : "/images/acrobat1.jpg"}alt='classes'/>
        </div>
      </Link>
      <Link to={`/portal/booking/classes/DetailEnroll/${item?._id}`}>
        <div className='kiga-classes-section-title'>
        <p>{item?.name}</p>
        </div>
      </Link>
      <div className='kiga-classes-section-schedule'>
        <div className='kiga-classes-section-schedule-date'>
          <p>{item?.date}</p>
        </div>
        <div className='kiga-schedule-activity'>
         <p >{item?.status ? item?.status : 'opened'}</p>
        </div>
      </div>
      <div className='kiga-classes-section-days'>
        {
          item?.day?.map((item,key)=>(
            <p key={key}>
              {item}
            </p>
          ))
        }
      </div>
     </div>
        ))
      }

    </section>
      )
    }
    <Footer/>
    </div>
  )
}

export default Details